<template>
	<div class="ChartProgress">
		<div class="header">
			{{header}}
		</div>
		<div class="body">
			<v-progress-circular :indeterminate="isLoading" :rotate="-90" :size="100" :width="15" :value="getValue" :color="getColor">
				{{ getValueText }}
			</v-progress-circular>
		</div>
		<div class="footer" v-if="footer">
			{{footer}}
		</div>
	</div>
</template>


<script>
	export default {
		name: "ChartProgress",
		props: {
			header: {
				type: String,
				defualt: ""
			},
			footer: {
				type: String,
				defualt: ""
			},
			value: {
				default : 0
			},
			critical: { 
				default: 9999999
			},
			color: {
				type: String,
				default: ""
			},
			isLoading: {
				type: Boolean,
				default: true
			}
		},
		data: () => ({

		}),

		computed: {
			getValue() { 
				var i = parseInt(this.value);
				return i > 100 ? 100 : parseInt(this.value);
			},
			getValueText() {
				return parseFloat(this.value).toFixed(2);
			},
			getColor() {
				if (this.color == "") {
					var oran = parseInt(this.getValue) * 100 / parseInt(this.critical);
					var color = "success";
					if(oran > 50){ color = "orange" }
					if(oran > 90){ color = "error" }
					return color;
				}
				return this.color;
			}
		}
	}
</script>


<style lang="less" >
	.ChartProgress {
		background-color: #fff;
		border-radius: 4px;
		box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12) !important;
		padding: 10px;

		.header {
			font-weight: 500
		}

		.body {
			text-align: center;
			margin:15px 0px;
		}

		.footer{
			color : #888;
			@media(max-width:940px) and (min-width: 750px){
				font-size:11px; 
			}
			@media(max-width:400px){
				font-size:11px; 
			}
		}
	}
</style>